/**
 * Array con los nombres de los meses en español
 */
export const months = [
  'enero',
  'febrero',
  'marzo',
  'abril',
  'mayo',
  'junio',
  'julio',
  'agosto',
  'septiembre',
  'octubre',
  'noviembre',
  'diciembre'
]

/**
 * Obtiene las categorías de KPI basadas en un rango de fechas
 * Genera una categoría por cada mes dentro del rango con el formato 'kpi_[mes]_[año]'
 *
 * @param {Date} initial_date - Fecha inicial del rango
 * @param {Date} final_date - Fecha final del rango
 * @returns {string[]} Array con las categorías de KPI generadas
 */
export const getCategories = (initial_date: Date, final_date: Date) => {
  const categories = new Set<string>()

  const startYear = initial_date.getFullYear()
  const startMonth = initial_date.getMonth()

  const endYear = final_date.getFullYear()
  const endMonth = final_date.getMonth()

  const totalMonths = (endYear - startYear) * 12 + (endMonth - startMonth + 1)

  for (let i = 0; i < totalMonths; i++) {
    const currentMonth = (startMonth + i) % 12
    const currentYear = startYear + Math.floor((startMonth + i) / 12)

    const monthName = months[currentMonth]
    const category = `kpi_${monthName}_${currentYear}`
    categories.add(category)
  }

  return Array.from(categories)
}
